import * as caseUploadTypes from './caseUploadTypes';

const initialState = {
  dateFrom_input: undefined,
  dateTo_input: undefined,
};

const caseUploadFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case caseUploadTypes.CLEAR_FILTER:
      return { ...state, ...initialState };

    case caseUploadTypes.ON_CHANGE:
      return {
        ...state,
        ...action.payload,
      };

    case caseUploadTypes.ON_CHANGE_DATE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export { initialState };
export default caseUploadFilterReducer;
